import Typography from '@mui/material/Typography';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { TopBarBase } from 'shared/components/connected/top-bar-base';
import { useDelayedCallback } from 'shared/hooks/use-delayed-callback';

import { TemplateSearch } from '../template-search';
import * as Styled from './page-top-bar.style';

export type PageTopBarProps = {
  initialSearch: string;
  onSearch: (search: string) => void;
};

export const PageTopBar: React.FC<PageTopBarProps> = ({
  initialSearch,
  onSearch,
}) => {
  const { t } = useTranslation();
  const [onChangeSearch] = useDelayedCallback(onSearch, 500);

  return (
    <TopBarBase>
      <Styled.Container>
        <Styled.Title>
          <Typography variant="h6" component="h1">
            {t('pages.goal-templates.title')}
          </Typography>
        </Styled.Title>

        <Styled.InteractionsContainer>
          <TemplateSearch
            initialValue={initialSearch}
            onChange={onChangeSearch}
          />
        </Styled.InteractionsContainer>
      </Styled.Container>
    </TopBarBase>
  );
};
